<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                   <sidebar></sidebar>
                </el-aside>
                <el-main>
                    <contTitle  :obj="obj" :contTitle="contTitle"></contTitle>
                    <companySide class="mt-30" :isButton="isButton"></companySide>
                    <div class="mt-30">
                          <paletteBar :paletteObj="paletteObj"  @onPaletteBar="addInvoice()"></paletteBar>
                          <div class="invoice_box">
                             <div class="invoice_list" v-for="(item,index) in list" :key="index" >
                                <p>
                                  <span>申请邮箱:</span>
                                  <span>{{item.content}}</span>
                                </p>
                                <p class="fsb">
                                  <span class="invoice_ter">申请内容:</span>
                                  <span class="invoice_tetx">{{item.msg}}</span>
                                </p>
                                <p>
                                  <span>申请时间:</span>
                                  <span v-if="item.createtime">{{item.createtime.substring(0,10)}}</span>
                                </p>
                                <p>
                                  <span>审核状态:</span>
                                  <span :class="[item.step == '100'?'gren':item.step == '101'?'err':'']">{{item.step == '1'?'待审核':item.step == '2'?'需认证':item.step == '3'?'需支付':item.step == '100'?'审核成功':item.step =='101'?'审核拒绝':''}}</span>
                                </p>
                             </div>
                          </div>
                    </div>
                  <!--分页-->
                  <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>

                   <div style="margin-top:20%">
                         <notList :notCode="notCode"></notList>
                  </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {getToken} from '@/utils/auth'
import {sendface,sendinvoice,getinvoicelist} from '@/api/coment'
import sidebar from '../../common/sidebar'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import paletteBar from '../../common/paletteBar'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
     sidebar,companySide,commBanner,titleHead,contTitle,paletteBar,Pagination,notList
  },
  data(){
      return{
        headTitle:'发票申请',
        contTitle:'企业基本信息',
        contTitles:'发票申请',
        obj:{
           title:'我的发票',
           isShow:false,
           isColor:false,
           roleType:3,
           personalType:9
        },
        isButton:false,
        listQuery:{
          curPage:1,
          limit:5
        },
        total:0,
        list:[],
        paletteObj:{
            paletteTitle:'申请发票',
            paletteCount:'',
            paletteName:'添加申请',
        },
        notCode:false
      }
  },
  created(){
     this.id = this.$store.state.user.userInfo.data.userId
     this.getList();
  },
  methods:{
    //添加
    addInvoice(){
      this.$router.push('/corporate_invoiceAdd')
    },
	  getList(){
      getinvoicelist(this.listQuery).then((res)=>{
        if(res.code == 0){
          this.list = res.data.list;
          this.total = res.data.totalCount;
          this.list.length >0 ? this.notCode = false : this.notCode = true;
        }
      }).catch((err)=>{})
    },
    pageChange(item){
      this.listQuery['curPage'] = item.page;
      this.listQuery['limit'] = item.limit;
      this.getList();
    }
  }
}
</script>
<style scoped="scoped">
.el-aside{
    height:100%;
}
.mt-30{
    margin-top: 30px;
}
.fsb{
  display: flex;
  justify-content: flex-start;
}
.invoice_box{
  margin-top:20px;
}
.invoice_list{
  border: 1px solid #DEDEDE;
  margin: 15px 0px;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 20px 15px;
  transition: all 0.5s;
}
.invoice_list:hover{
  cursor: pointer;
  box-shadow: 0 0 20px #ddd;
}
.invoice_list p{
  font-size: 14px;
  color: #999999;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-bottom: 8px;
}
.invoice_tetx{
  word-break:normal;
  display: inline-block;
  display:-webkit-box;
  line-height: 1.4;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:88%;
}
.err{
  color: #ef9c9a;
}
.gren{
   color: #56c451;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_invoice.vue